import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Container } from 'semantic-ui-react';
import { Media } from '../../../../mediaSetting';
import PageHeader from '../../header';
import CenterPanel from './centerPanel';
import RightPanelOrTopPanel from './rightPanelOrTopPanel';
import AccordionSession from './accordion';
import BottomLogo from '../../../shared/bottom-logo/content.js';
import WaitingAreaAddUsersModal from './addUsersModal';
import ManageRolesForUsersModal from 'containers/WaitingAreaManageRolesForUsersModal';
import { previousPage } from 'actions/navigationBar';
import { queueESEvents, ESEventTypes } from 'businessLogic/logEventToElasticSearch';
import {
  selectWaitingArea,
  getWaitingArea,
  updateWaitingAreaMemberSearch,
  getAvailableRoles,
} from '../../../../actions/waitingArea';
import { getWaitingAreaUsers } from '../../../../actions/user';

import { hideWhenClickAwayOrResize } from '../../../shared/contextualMenu/content';

export default function WaitingAreaManageUsersContent(props) {
  const dispatch = useDispatch();
  const [fetchingUserICanManage, setFetchingUserICanManage] = useState(false);

  useEffect(() => {
    window.addEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    window.addEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));

    let cb = () => {
      let cbForGetUsers = () => {
        setFetchingUserICanManage(false);
        dispatch(getAvailableRoles(props.id));
      };
      dispatch(getWaitingAreaUsers(props.id, cbForGetUsers));
    };
    setFetchingUserICanManage(true);
    dispatch(selectWaitingArea(props.id));
    queueESEvents(
      ESEventTypes.APICall,
      `In manage-users: ${props.id}`,
      'eventType&apiURL',
      {
        apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + props.id + '/calls',
        browserURL: window.location.href,
      },
      null,
      true,
      'info'
    );
    dispatch(getWaitingArea(props.id, cb));

    return () => {
      dispatch(updateWaitingAreaMemberSearch(''));
      window.removeEventListener('click', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
      window.removeEventListener('resize', (event) => hideWhenClickAwayOrResize('.waiting-area-view-one', event));
    };
  }, []);

  const onSearchTermInputChange = (e) => {
    console.log('WaitingAreaManageUsersContent.onSearchTermInputChange: ', e);

    if (e.target != undefined) dispatch(updateWaitingAreaMemberSearch(e.target.value));
    else dispatch(updateWaitingAreaMemberSearch(e));
  };

  let modals = (
    <div>
      {props.showManageRolesForUsersModal && (
        <ManageRolesForUsersModal
          usersIcanManage={props.usersIcanManage}
          waitingArea={props.waitingArea}
          availableRoles={props.availableRoles}
        />
      )}
      {props.showWaitingAreaAddUsersModal && props.waitingArea && props.availableRoles && (
        <WaitingAreaAddUsersModal
          waitingArea={props.waitingArea}
          availableRoles={props.availableRoles}
          dispatch={dispatch}
        />
      )}
    </div>
  );
  let bottomSession = <AccordionSession waitingArea={props.waitingArea} userId={props.userId} />;
  let isWaitingAreaLoaded = props.waitingArea && props.waitingArea.id > 0;

  return (
    <div className="main-ui-container waiting-area-view-one new-waiting-area-view-one">
      <Container fluid as={Media} greaterThanOrEqual="computer" className="row">
        <div className="left-hand-side-panel">
          <div className="relative mrrm">
            <PageHeader
              classes="waiting-area-title"
              subHeaderClass="waiting-area-sub-title"
              title={APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle}
              titleColor="color-waiting-area-text"
              subHeader={
                props.waitingArea.name
                  ? APP.LANGUAGE.WaitingAreaManageUsers.PageSubHeaderTitle.replace(
                      '##waitingAreaName##',
                      props.waitingArea.name.trim()
                    ).replace('##organisationAbbreviatedName##', props.waitingArea.organisationAbbreviatedName.trim())
                  : 'Loading...'
              }
              notRenderLogo={true}
              linkTo={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? `/organisational-unit/view-all`
                  : `/waiting-area/view-one/${props.waitingArea.id}`
              }
              linkText={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText
                  : APP.LANGUAGE.WaitingAreaManageUsers.BackToWaitingAreaLinkText
              }
              linkClass={
                props.previousPage === window.APP.LANGUAGE.ViewAllOrgUnit.Title
                  ? 'back-to-org-link'
                  : 'color-waiting-area-text'
              }
              linkOnClick={() => {
                dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle));
              }}
              showLinkCondition={isWaitingAreaLoaded}
            >
              <span>
                <img
                  className="ui image  mrrnull fl pdrs header-icon mrtsss"
                  src={APP.IMAGES.UserManagementPageIcon.default}
                />
              </span>
            </PageHeader>
          </div>
          <div className="manage-users-waiting-area-container pdlm pdrm">
            <CenterPanel
              showManageRolesForUsersModal={props.showManageRolesForUsersModal}
              waitingArea={props.waitingArea}
              usersIcanManage={props.usersIcanManage}
              searchTerm={props.searchTerm}
              dispatch={dispatch}
              fetchingUserICanManage={fetchingUserICanManage}
              availableRoles={props.availableRoles}
              onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
              timezone={props.timezone}
              isOnMobileOrTablet={false}
            />
          </div>
        </div>
        <div className="right-hand-side-panel color-right-hand-side-panel-bg">
          <RightPanelOrTopPanel
            waitingArea={props.waitingArea}
            availableRoles={props.availableRoles}
            bottomSession={bottomSession}
            dispatch={dispatch}
            usersIcanManage={props.usersIcanManage}
            previousPage={props.previousPage}
            fetchingUserICanManage={fetchingUserICanManage}
          />
        </div>
      </Container>
      <Container fluid as={Media} lessThan="computer">
        <div className="left-hand-side-panel-mobile">
          <PageHeader
            classes="waiting-area-title"
            subHeaderClass="waiting-area-sub-title"
            title={APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle}
            titleColor="color-waiting-area-text"
            subHeader={
              props.waitingArea.name
                ? APP.LANGUAGE.WaitingAreaManageUsers.PageSubHeaderTitle.replace(
                    '##waitingAreaName##',
                    props.waitingArea.name.trim()
                  ).replace('##organisationAbbreviatedName##', props.waitingArea.organisationAbbreviatedName.trim())
                : 'Loading...'
            }
            notRenderLogo={true}
            linkTo={`/organisational-unit/view-all`}
            linkText={APP.LANGUAGE.OrganisationalUnitManageUsers.BackToOrganisationalUnitLinkText}
            linkClass="color-waiting-area-text"
            linkOnClick={() => {
              dispatch(previousPage(APP.LANGUAGE.WaitingAreaManageUsers.PageHeaderTitle));
            }}
            showLinkCondition={isWaitingAreaLoaded}
          >
            <span>
              <img
                className="ui image  mrrnull fl pdrs header-icon mrtsss"
                src={APP.IMAGES.UserManagementPageIcon.default}
              />
            </span>
          </PageHeader>
          <div className="right-hand-side-panel-mobile">
            <RightPanelOrTopPanel
              waitingArea={props.waitingArea}
              availableRoles={props.availableRoles}
              bottomSession={bottomSession}
              dispatch={dispatch}
              usersIcanManage={props.usersIcanManage}
              previousPage={props.previousPage}
              fetchingUserICanManage={fetchingUserICanManage}
            />
          </div>
          <div>
            <CenterPanel
              showManageRolesForUsersModal={props.showManageRolesForUsersModal}
              waitingArea={props.waitingArea}
              usersIcanManage={props.usersIcanManage}
              searchTerm={props.searchTerm}
              dispatch={dispatch}
              fetchingUserICanManage={fetchingUserICanManage}
              availableRoles={props.availableRoles}
              onSearchTermInputChange={(e) => onSearchTermInputChange(e)}
              timezone={props.timezone}
              isOnMobileOrTablet={true}
            />
          </div>
          <div className="mrtl right-hand-side-bottom-on-mobile">
            {bottomSession}
            <BottomLogo />
          </div>
        </div>
      </Container>
      {modals}
    </div>
  );
}

WaitingAreaManageUsersContent.propTypes = {
  id: PropTypes.number,
  waitingArea: PropTypes.object,
  usersIcanManage: PropTypes.array.isRequired,
  searchTerm: PropTypes.string,
  availableRoles: PropTypes.array,
  showWaitingAreaAddUsersModal: PropTypes.bool,
};
